import React, { useContext, useEffect, useState } from "react"
import { db, auth } from "../../../../utils/firebase"
import { AlertsContext } from "../../../../utils/providers/alerts"
import { reassignBookingAgent } from "../../../../utils/bookings/reassign-agent"

import Window from "../../../../components/structure/window/window"
import Button from "../../../../components/ui/button/button"

/**
 * Window for reassigning an existing booking to a different sales agent.
 * Mirrors the look & feel of the enquiry / direct-booking assign windows.
 */
export default function AssignAgent({ bookingID, currentAgent, agentsByUID, close, onAssigned }) {
	const [agents, setAgents] = useState([])
	const [assigning, setAssigning] = useState({})

	const { pushAlert } = useContext(AlertsContext)

	useEffect(() => {
		db.collection("users")
			.orderBy("first_name")
			.where("show_for.assignable", "==", true)
			.get()
			.then((agentDocs) => {
				const assignable = []
				agentDocs.forEach((agentDoc) => {
					assignable.push({ ...agentDoc.data(), id: agentDoc.id })
				})
				setAgents(assignable)
			})
	}, [])

	const assignToAgent = async (agentID) => {
		if (agentID === currentAgent) {
			close()
			return
		}

		setAssigning({ [agentID]: true })

		try {
			const result = await reassignBookingAgent(bookingID, agentID, auth.currentUser.uid, agentsByUID)

			if (result.changed) {
				pushAlert({
					type: "SUCCESS",
					title: "Booking reassigned",
				})
				if (onAssigned) onAssigned(bookingID, agentID)
			}
		} catch (error) {
			console.error("Failed to reassign booking:", error)
			pushAlert({
				type: "ERROR",
				title: "Could not reassign booking",
			})
		}

		setAssigning({ [agentID]: false })
		close()
	}

	return (
		<Window
			title="Assign to agent"
			className="slim"
			close={() => close()}>
			<div className="assign-agent-wrap">
				<table className="assign-agent-table">
					<tbody>
						{agents.map((agent) => {
							const isCurrent = agent.id === currentAgent
							return (
								<tr key={agent.id}>
									<td>
										{agent.first_name} {agent.last_name}
										{isCurrent && <small className="no-value"> (current)</small>}
									</td>
									<td>
										<Button
											label={isCurrent ? "Current" : "Assign"}
											loading={assigning[agent.id]}
											small={true}
											loadingText="Assigning..."
											disabled={isCurrent}
											onClick={() => assignToAgent(agent.id)}
										/>
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</Window>
	)
}
